(function () {
  'use strict';

  function init(root) {
    if (!root || !root.querySelector) return;
    var pdp = root.querySelector('.bc-pdp-root') || (root.classList && root.classList.contains('bc-pdp-root') ? root : null);
    if (!pdp) return;

    initVariantSelection(pdp);
    initQty(pdp);
    initAtcForm(pdp);
    initAccordionMobile(pdp);
    initGallery(pdp);
    initLightbox(pdp);
    initCampaignCountdown(pdp);
    initWishlist(pdp);
    initCompare(pdp);
    initRelatedSliders(pdp);
    initRecommendations(pdp);
    initStickyBar(pdp);
    initAddonPreview(pdp);
  }

  function initAddonPreview(root) {
    var triggers = root.querySelectorAll('[data-bc-eb-preview-trigger]');
    if (!triggers.length) return;
    var hoverCapable = window.matchMedia('(hover: hover)').matches;
    var openPrev = null, openTrig = null, hideTimer = null;
    var isSheet = function () { return window.matchMedia('(max-width: 639px)').matches; };

    function position(trigger, prev) {
      if (isSheet()) { prev.style.top = ''; prev.style.left = ''; return; }
      var r = trigger.getBoundingClientRect();
      var pw = prev.offsetWidth || 270;
      var ph = prev.offsetHeight || 170;
      var m = 8;
      var left = Math.min(Math.max(m, r.left), window.innerWidth - pw - m);
      var top = r.top > ph + m ? r.top - ph - m : r.bottom + m;
      top = Math.min(Math.max(m, top), window.innerHeight - ph - m);
      prev.style.left = left + 'px';
      prev.style.top = top + 'px';
    }

    function open(trigger, prev) {
      if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
      if (openPrev && openPrev !== prev) close(true);
      prev.hidden = false;
      position(trigger, prev);
      void prev.offsetWidth;
      prev.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      openPrev = prev; openTrig = trigger;
    }

    function close(immediate) {
      if (!openPrev) return;
      var prev = openPrev, trig = openTrig;
      prev.classList.remove('is-open');
      if (trig) trig.setAttribute('aria-expanded', 'false');
      openPrev = null; openTrig = null;
      var done = function () { prev.hidden = true; prev.style.top = ''; prev.style.left = ''; };
      if (immediate) { done(); } else { hideTimer = setTimeout(done, 170); }
    }

    triggers.forEach(function (trigger) {
      var prev = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!prev) return;
      var card = trigger.closest('.bc-eb__card');
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (openPrev === prev) close(true); else open(trigger, prev);
      });
      if (hoverCapable) {
        trigger.addEventListener('mouseenter', function () { open(trigger, prev); });
        if (card) card.addEventListener('mouseleave', function () { if (openPrev === prev) close(); });
        prev.addEventListener('mouseenter', function () { if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; } });
        prev.addEventListener('mouseleave', function () { if (openPrev === prev) close(); });
      }
    });

    root.querySelectorAll('[data-bc-eb-preview-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { var t = openTrig; close(true); if (t) t.focus(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openPrev) { var t = openTrig; close(true); if (t) t.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (openPrev && !e.target.closest('[data-bc-eb-preview]') && !e.target.closest('[data-bc-eb-preview-trigger]')) close(true);
    });
    window.addEventListener('scroll', function () { if (openPrev && !isSheet()) close(true); }, true);
  }

  function initRelatedSlider(container) {
    var track = container.querySelector('[data-bc-slider-track]');
    if (!track) return;
    if (container._bcSliderInit) { container._bcSliderUpdate && container._bcSliderUpdate(); return; }
    container._bcSliderInit = true;
    var prevBtn = container.querySelector('[data-bc-slider-prev]');
    var nextBtn = container.querySelector('[data-bc-slider-next]');
    var nav = container.querySelector('[data-bc-slider-nav]');
    var progressBar = container.querySelector('[data-bc-slider-progress-bar]');

    function getStep() {
      var item = track.querySelector('.bc-pdp-related__item') || track.firstElementChild;
      if (!item) return track.clientWidth;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = Math.max(0, track.scrollWidth - track.clientWidth);
      var canScroll = max > 4;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max - 2;

      if (nav) nav.hidden = !canScroll;
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd;
      container.classList.toggle('is-at-start', atStart);
      container.classList.toggle('is-at-end', atEnd);
      container.classList.toggle('is-static', !canScroll);

      if (progressBar) {
        var pct = max > 0 ? (track.scrollLeft / max) * 100 : 0;
        progressBar.style.width = Math.min(100, Math.max(0, pct)) + '%';
      }
    }

    function scrollByStep(dir) {
      track.scrollBy({ left: dir * getStep(), behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByStep(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByStep(1); });

    track.addEventListener('scroll', update, { passive: true });

    var DRAG_THRESHOLD = 8;
    var pointerDown = false;
    var isDragging = false;
    var capturedPointerId = null;
    var startX = 0;
    var startScroll = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      pointerDown = true;
      isDragging = false;
      capturedPointerId = null;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (!pointerDown) return;
      var dx = e.clientX - startX;
      if (!isDragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        isDragging = true;
        track.classList.add('is-dragging');
        try { track.setPointerCapture(e.pointerId); capturedPointerId = e.pointerId; } catch (_) {}
      }
      track.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!pointerDown) return;
      pointerDown = false;
      if (isDragging) {
        track.classList.remove('is-dragging');
        if (capturedPointerId !== null) {
          try { track.releasePointerCapture(capturedPointerId); } catch (_) {}
        }
      }
      capturedPointerId = null;
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    track.addEventListener('click', function (e) {
      if (isDragging) {
        e.preventDefault();
        e.stopPropagation();
        isDragging = false;
      }
    }, true);

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByStep(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); scrollByStep(1); }
      else if (e.key === 'Home') { e.preventDefault(); track.scrollTo({ left: 0, behavior: 'smooth' }); }
      else if (e.key === 'End') { e.preventDefault(); track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); }
    });

    container._bcSliderUpdate = update;

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(update).observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    update();
  }

  function initRelatedSliders(root) {
    root.querySelectorAll('.bc-pdp-related').forEach(function (container) {
      initRelatedSlider(container);
    });
  }

  function initLightbox(root) {
    var triggers = root.querySelectorAll('[data-bc-gallery] a[data-fancybox]');
    if (!triggers.length) return;

    var items = Array.from(triggers).map(function (a) {
      var img = a.querySelector('img');
      return {
        src: a.getAttribute('data-src') || a.getAttribute('href'),
        alt: img ? img.alt : ''
      };
    });
    if (!items.length) return;

    var current = 0;
    var modal = null;
    var imgEl = null;
    var counterEl = null;
    var prevBtn = null;
    var nextBtn = null;

    function build() {
      if (modal) return;
      modal = document.createElement('div');
      modal.className = 'bc-lightbox';
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.innerHTML =
        '<button type="button" class="bc-lightbox__close" data-bc-lb-close aria-label="Close">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
        '</button>' +
        '<button type="button" class="bc-lightbox__nav bc-lightbox__nav--prev" data-bc-lb-prev aria-label="Previous">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>' +
        '</button>' +
        '<button type="button" class="bc-lightbox__nav bc-lightbox__nav--next" data-bc-lb-next aria-label="Next">' +
          '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>' +
        '</button>' +
        '<div class="bc-lightbox__stage">' +
          '<img class="bc-lightbox__img" alt="">' +
        '</div>' +
        '<div class="bc-lightbox__counter" aria-live="polite"></div>';
      document.body.appendChild(modal);
      imgEl = modal.querySelector('.bc-lightbox__img');
      counterEl = modal.querySelector('.bc-lightbox__counter');
      prevBtn = modal.querySelector('[data-bc-lb-prev]');
      nextBtn = modal.querySelector('[data-bc-lb-next]');

      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      modal.querySelector('[data-bc-lb-close]').addEventListener('click', close);
      prevBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
      nextBtn.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });

      if (items.length <= 1) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        counterEl.style.display = 'none';
      }
    }

    function show(idx) {
      current = ((idx % items.length) + items.length) % items.length;
      var item = items[current];
      imgEl.src = item.src;
      imgEl.alt = item.alt;
      counterEl.textContent = (current + 1) + ' / ' + items.length;
    }

    function open(idx) {
      build();
      show(idx);
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.classList.add('bc-lightbox-open');
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!modal) return;
      modal.classList.remove('is-open');
      document.body.classList.remove('bc-lightbox-open');
      document.removeEventListener('keydown', onKey);
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft' && items.length > 1) show(current - 1);
      else if (e.key === 'ArrowRight' && items.length > 1) show(current + 1);
    }

    triggers.forEach(function (a, i) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        open(i);
      });
    });
  }

  function fetchSlotHTML(url) {
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.bc-pdp-recs-slot');
        var content = inner ? inner.innerHTML.trim() : '';
        return content || null;
      })
      .catch(function () { return null; });
  }

  function fetchRecsHTML(productId, intent, limit) {
    var url = '/recommendations/products?section_id=bc-pdp-recs'
            + '&product_id=' + encodeURIComponent(productId)
            + '&intent=' + encodeURIComponent(intent)
            + '&limit=' + limit;
    return fetchSlotHTML(url);
  }

  function fetchCollectionFallbackHTML() {
    var path = window.location.pathname;
    var m = path.match(/\/products\/[^/?#]+/);
    if (!m) return Promise.resolve(null);
    return fetchSlotHTML(m[0] + '?section_id=bc-pdp-collection-fallback');
  }

  function injectRecs(slot, content) {
    var slotEl = slot.querySelector('[data-bc-recs-slot]');
    if (slotEl) slotEl.innerHTML = content;
    slot.removeAttribute('hidden');
    initRelatedSlider(slot);
  }

  function collectHandles(htmlOrEl) {
    var scope;
    if (typeof htmlOrEl === 'string') {
      scope = new DOMParser().parseFromString(htmlOrEl, 'text/html');
    } else {
      scope = htmlOrEl;
    }
    var handles = [];
    scope.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      if (m && handles.indexOf(m[1]) === -1) handles.push(m[1]);
    });
    return handles;
  }

  function filterCardsByHandle(content, excludeHandles, limit) {
    var doc = new DOMParser().parseFromString('<div>' + content + '</div>', 'text/html');
    var items = doc.querySelectorAll('.bc-pdp-related__item');
    var kept = [];
    items.forEach(function (item) {
      if (kept.length >= limit) return;
      var handles = collectHandles(item);
      var dup = handles.some(function (h) { return excludeHandles.indexOf(h) !== -1; });
      if (!dup) kept.push(item.outerHTML);
    });
    return kept.join('');
  }

  function initRecommendations(root) {
    var slots = root.querySelectorAll('[data-bc-recs]');
    if (!slots.length) return;

    var relatedSlot = null;
    var complementarySlot = null;
    slots.forEach(function (slot) {
      var intent = slot.getAttribute('data-bc-recs');
      if (intent === 'related') relatedSlot = slot;
      else if (intent === 'complementary') complementarySlot = slot;
    });

    var relatedDone = Promise.resolve();
    if (relatedSlot) {
      var rid = relatedSlot.getAttribute('data-bc-product-id');
      if (rid) {
        relatedDone = fetchRecsHTML(rid, 'related', 10).then(function (content) {
          if (content) injectRecs(relatedSlot, content);
        });
      }
    }

    if (complementarySlot) {
      var cid = complementarySlot.getAttribute('data-bc-product-id');
      if (!cid) return;
      fetchRecsHTML(cid, 'complementary', 10).then(function (content) {
        if (content) {
          injectRecs(complementarySlot, content);
          return;
        }
        // Fallback chain (after first slider resolves so we can dedup):
        //  1. intent=related&limit=20, dedup against slider 1
        //  2. if that yields nothing, collection bestsellers, dedup against slider 1
        relatedDone.then(function () {
          var firstSlider = document.querySelector('.bc-pdp-related');
          var excluded = firstSlider ? collectHandles(firstSlider) : [];
          fetchRecsHTML(cid, 'related', 20).then(function (relatedContent) {
            var filtered = relatedContent ? filterCardsByHandle(relatedContent, excluded, 10) : '';
            if (filtered) {
              injectRecs(complementarySlot, filtered);
              return;
            }
            fetchCollectionFallbackHTML().then(function (fbContent) {
              if (!fbContent) return;
              var fbFiltered = filterCardsByHandle(fbContent, excluded, 10);
              if (fbFiltered) injectRecs(complementarySlot, fbFiltered);
            });
          });
        });
      });
    }
  }

  function findVariantForPicks(picks) {
    if (!window.bcPdpVariants) return null;
    return window.bcPdpVariants.find(function (v) {
      for (var i = 0; i < v.options.length; i++) {
        var key = 'option-' + (i + 1);
        if (picks[key] !== undefined && picks[key] !== v.options[i]) return false;
      }
      return true;
    });
  }

  function applySelectedClasses(root, selected) {
    root.querySelectorAll('.variantSelector').forEach(function (sel) {
      sel.classList.remove('is-selected');
    });
    if (selected) selected.classList.add('is-selected');
  }

  function updateStockIndicator(root, data) {
    var wrap = root.querySelector('[data-bc-pdp-stock]');
    var dot = root.querySelector('[data-bc-pdp-stock-dot]');
    var text = root.querySelector('[data-bc-pdp-stock-text]');
    if (!wrap || !dot || !text || !data) return;

    var state = data.stockState === 'green' || data.stockState === 'yellow' || data.stockState === 'red'
      ? data.stockState
      : 'red';

    wrap.setAttribute('data-stock-state', state);
    dot.classList.remove('bc-card__dot--green', 'bc-card__dot--yellow', 'bc-card__dot--red');
    dot.classList.add('bc-card__dot--' + state);

    if (data.stockText) {
      text.textContent = data.stockText;
    }
  }

  function findBaselinePerUnit() {
    // baseline = variant whose packSize === 1; fall back to lowest per-unit
    var map = window.bcPdpVariantData || {};
    var baseline = null;
    Object.keys(map).forEach(function (id) {
      var d = map[id];
      if (!d || !d.priceCents || !d.packSize) return;
      if (d.packSize === 1) baseline = d.priceCents / 1;
    });
    if (baseline == null) {
      Object.keys(map).forEach(function (id) {
        var d = map[id];
        if (!d || !d.priceCents || !d.packSize) return;
        var pu = d.priceCents / d.packSize;
        if (baseline == null || pu < baseline) baseline = pu;
      });
    }
    return baseline;
  }

  function formatMoneyCents(cents) {
    // Reuse Shopify-formatted strings where possible; fall back to a simple format.
    // priceFormatted on the variant is the total; per-unit needs derivation, so
    // format with the store's pattern via Intl as a safe default.
    var amount = cents / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'nb-NO', {
        style: 'currency', currency: (window.BCCurrency || 'NOK'),
        minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(amount);
    } catch (_) {
      return amount.toFixed(2);
    }
  }

  function updateVolumePricing(root, data) {
    var wrap = root.querySelector('[data-bc-perunit]');
    if (!wrap || !data || !data.priceCents || !data.packSize) { if (wrap) wrap.hidden = true; return; }
    if (data.packSize <= 1) { wrap.hidden = true; return; } // no per-unit line for single units
    var perUnit = data.priceCents / data.packSize;
    var unitEl = wrap.querySelector('[data-bc-perunit-price]');
    var saveEl = wrap.querySelector('[data-bc-perunit-save]');
    if (unitEl) {
      var tpl = (window.BCStrings && window.BCStrings.per_unit) || '__PRICE__ per stk';
      unitEl.textContent = tpl.replace('__PRICE__', formatMoneyCents(perUnit));
    }
    var baseline = findBaselinePerUnit();
    if (saveEl && baseline && baseline > perUnit) {
      var pct = Math.round((1 - perUnit / baseline) * 100);
      if (pct > 0) {
        var stpl = (window.BCStrings && window.BCStrings.volume_save) || 'Spar __PCT__%';
        saveEl.textContent = stpl.replace('__PCT__', String(pct));
        saveEl.hidden = false;
      } else { saveEl.hidden = true; }
    } else if (saveEl) { saveEl.hidden = true; }
    wrap.hidden = false;
  }

  function updateLowStock(root, data) {
    var el = root.querySelector('[data-bc-lowstock]');
    if (!el || !data) { if (el) el.hidden = true; return; }
    var threshold = parseInt(el.getAttribute('data-threshold') || '10', 10);
    // maxQty is non-null only when inventory is tracked + policy deny + qty > 0 (set in Liquid).
    var qty = (data.maxQty != null) ? parseInt(data.maxQty, 10) : null;
    if (qty != null && qty > 0 && qty <= threshold) {
      var txt = root.querySelector('[data-bc-lowstock-text]');
      if (txt) {
        var tpl = (window.BCStrings && window.BCStrings.low_stock) || 'Kun __N__ igjen';
        txt.textContent = tpl.replace('__N__', String(qty));
      }
      el.hidden = false;
    } else {
      el.hidden = true;
    }
  }

  function initVariantSelection(root) {
    var inputs = root.querySelectorAll('.variant-input-field');
    if (!inputs.length) return;

    var checked = root.querySelector('.variant-input-field:checked');
    if (checked) applySelectedClasses(root, checked.closest('.variantSelector'));

    if (checked) {
      var initVid = (checked.getAttribute('data-variant-id') || '');
      var initData = window.bcPdpVariantData && window.bcPdpVariantData[initVid];
      if (initData) updateVolumePricing(root, initData);
      if (initData) updateLowStock(root, initData);
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        applySelectedClasses(root, input.closest('.variantSelector'));

        var picks = {};
        root.querySelectorAll('.variant-input-field:checked').forEach(function (r) {
          picks[r.name] = r.value;
        });
        var variant = findVariantForPicks(picks);
        if (!variant) return;

        var idEl = root.querySelector('[data-bc-pdp-id]');
        if (idEl) idEl.value = variant.id;

        var data = window.bcPdpVariantData && window.bcPdpVariantData[variant.id];
        if (data) {
          updateStockIndicator(root, data);
          updateLowStock(root, data);

          var priceEl = root.querySelector('[data-product="price"]');
          if (priceEl && data.priceFormatted) priceEl.innerHTML = data.priceFormatted;

          updateVolumePricing(root, data);

          var compareEl = root.querySelector('[data-product="compare-at-price"]');
          if (compareEl) {
            if (data.compareAtFormatted && data.onSale) {
              compareEl.innerHTML = data.compareAtFormatted;
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }

          var saleBadge = root.querySelector('[data-bc-sale-badge]');
          if (saleBadge) {
            if (data.savingsPct && data.savingsPct > 0) {
              saleBadge.textContent = '-' + data.savingsPct + '%';
              saleBadge.style.display = '';
            } else {
              saleBadge.style.display = 'none';
            }
          }

          var skuEl = root.querySelector('[data-bc-pdp-sku]');
          if (skuEl && data.sku) skuEl.textContent = data.sku;

          var eanEl = root.querySelector('[data-bc-pdp-ean]');
          if (eanEl) {
            if (data.barcode) {
              eanEl.textContent = data.barcode;
              eanEl.parentNode.style.display = '';
            } else {
              eanEl.parentNode.style.display = 'none';
            }
          }

          if (data.image && root._bcGalleryGoTo) {
            root._bcGalleryGoTo(data.image);
          }

          var qtyInput = root.querySelector('[data-product="count"]');
          if (qtyInput) {
            if (data.maxQty != null) {
              qtyInput.setAttribute('max', String(data.maxQty));
              qtyInput.setAttribute('data-product-maxamount', String(data.maxQty));
            } else {
              qtyInput.removeAttribute('max');
              qtyInput.removeAttribute('data-product-maxamount');
            }
          }

          var actionsWrap = root.querySelector('[data-bc-pdp-actions]');
          var buyBtn = root.querySelector('[data-product="buyButton"]');
          if (actionsWrap && buyBtn) {
            if (data.available) {
              actionsWrap.classList.remove('opacity-60');
              actionsWrap.removeAttribute('aria-disabled');
              buyBtn.removeAttribute('disabled');
            } else {
              actionsWrap.classList.add('opacity-60');
              actionsWrap.setAttribute('aria-disabled', 'true');
              buyBtn.setAttribute('disabled', 'disabled');
            }
          }
        }

        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', variant.id);
          history.replaceState({}, '', u);
        } catch (_) {}

        root.dispatchEvent(new CustomEvent('bc:variant:changed', { detail: data, bubbles: true }));
      });
    });
  }

  function initStickyBar(root) {
    var bar = root.querySelector('[data-bc-sticky-bar]');
    if (!bar) return;
    var form = root.querySelector('[data-bc-pdp-form]');
    var mainBuy = root.querySelector('[data-product="buyButton"]');
    var stickyAtc = bar.querySelector('[data-bc-sticky-atc]');
    var stickyPrice = bar.querySelector('[data-bc-sticky-price]');
    var anchor = root.querySelector('[data-bc-pdp-actions]') || mainBuy;
    if (!anchor) return;

    // Sticky ATC submits the main form (single source of cart logic).
    if (stickyAtc && form) {
      stickyAtc.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    function reflectState() {
      if (!stickyAtc || !mainBuy) return;
      if (mainBuy.hasAttribute('disabled')) stickyAtc.setAttribute('disabled', 'disabled');
      else stickyAtc.removeAttribute('disabled');
    }

    // Show the bar only when the inline actions are scrolled out of view (mobile).
    var visible = false;
    function setVisible(v) {
      if (v === visible) return;
      visible = v;
      bar.hidden = !v;
      bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      bar.classList.toggle('is-visible', v);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { setVisible(!e.isIntersecting); });
      }, { rootMargin: '0px 0px -40% 0px' });
      io.observe(anchor);
    } else {
      window.addEventListener('scroll', function () {
        var r = anchor.getBoundingClientRect();
        setVisible(r.bottom < 0);
      }, { passive: true });
    }

    // Keep sticky price in sync with variant switches.
    root.addEventListener('bc:variant:changed', function (e) {
      var d = e.detail;
      if (stickyPrice && d && d.priceFormatted) stickyPrice.innerHTML = d.priceFormatted;
      reflectState();
    });

    // Init sync: a ?variant= deep-link preselect does NOT fire bc:variant:changed,
    // so set the sticky price once from the initially-checked variant (mirrors the
    // E3/E4 init pattern). stickyPrice only exists when show_price is true (guests
    // get the login link instead), so reading it here already honors show_price.
    if (stickyPrice) {
      var checked = root.querySelector('[data-variant-id]:checked') || root.querySelector('input[name="id"]:checked');
      var initVid = checked ? (checked.getAttribute('data-variant-id') || checked.value || '') : '';
      var initData = window.bcPdpVariantData && window.bcPdpVariantData[initVid];
      if (initData && initData.priceFormatted) stickyPrice.innerHTML = initData.priceFormatted;
    }

    reflectState();
  }

  function initQty(root) {
    var input = root.querySelector('[data-product="count"]');
    if (!input) return;
    root.querySelectorAll('[data-product="add"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var maxAttr = input.getAttribute('max');
        var max = maxAttr ? parseInt(maxAttr, 10) : 999;
        var v = parseInt(input.value || '1', 10);
        if (isNaN(v)) v = 1;
        if (v < max) input.value = String(v + 1);
      });
    });
    root.querySelectorAll('[data-product="subtract"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10);
        if (isNaN(v)) v = 1;
        if (v > 1) input.value = String(v - 1);
      });
    });
    input.addEventListener('input', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = '1';
      var maxAttr = input.getAttribute('max');
      if (maxAttr) {
        var max = parseInt(maxAttr, 10);
        if (v > max) input.value = String(max);
      }
    });
  }

  function collectExtraItems(root) {
    var out = [];
    root.querySelectorAll('[data-bc-extra-toggle]:checked').forEach(function (cb) {
      if (cb.disabled) return;
      var vid = cb.getAttribute('data-variant-id');
      if (vid) out.push({ id: parseInt(vid, 10), quantity: 1 });
    });
    return out;
  }

  function swapCartDrawerBody(sectionHtml) {
    if (!sectionHtml) return;
    var parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    var newBody = parsed.querySelector('[data-cart-drawer="body"]');
    var panel = document.querySelector('[data-cart-drawer="panel"]');
    var currentBody = panel && panel.querySelector('[data-cart-drawer="body"]');
    if (newBody && currentBody) currentBody.replaceWith(newBody);
  }

  function initAtcForm(root) {
    root.querySelectorAll('[data-bc-pdp-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        form.classList.remove('bc-pdp-form--error');

        var idEl = form.querySelector('[data-bc-pdp-id]');
        var qtyEl = form.querySelector('[data-product="count"]');
        var mainId = idEl ? parseInt(idEl.value, 10) : null;
        var mainQty = qtyEl ? parseInt(qtyEl.value || '1', 10) : 1;
        if (!mainId) { form.classList.add('bc-pdp-form--error'); return; }

        var extras = collectExtraItems(root);
        var items = [{ id: mainId, quantity: isNaN(mainQty) ? 1 : mainQty }].concat(extras);

        var addUrl = (form.getAttribute('action') || '/cart/add') + '.js';
        fetch(addUrl, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items, sections: 'cart-drawer' })
        })
          .then(function (r) {
            return r.json().then(function (data) { return { ok: r.ok, data: data }; });
          })
          .then(function (res) {
            if (!res.ok) {
              form.classList.add('bc-pdp-form--error');
              document.dispatchEvent(new CustomEvent('bc:cart:error', { detail: res.data }));
              return;
            }
            if (res.data.sections && res.data.sections['cart-drawer']) {
              swapCartDrawerBody(res.data.sections['cart-drawer']);
            }
            fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
              .then(function (x) { return x.json(); })
              .then(function (cart) {
                document.dispatchEvent(new CustomEvent('bc:cart:updated', {
                  detail: { count: cart.item_count, total: cart.total_price, currency: cart.currency, items: cart.items }
                }));
              })
              .catch(function () {});
            var statusEl = root.querySelector('[data-atc-status]');
            if (statusEl) {
              statusEl.textContent = (window.BCStrings && window.BCStrings.added_to_cart) || 'Lagt i handlekurv';
            }
            document.dispatchEvent(new CustomEvent('bc:cart:added', { detail: res.data }));
            document.dispatchEvent(new CustomEvent('bc:cart:open'));
            root.querySelectorAll('[data-bc-extra-toggle]:checked').forEach(function (cb) { cb.checked = false; });
          })
          .catch(function () { form.classList.add('bc-pdp-form--error'); });
      });
    });
  }

  function initAccordionMobile(root) {
    var acc = root.querySelector('.bc-acc');
    if (!acc) return;
    var mq = window.matchMedia('(max-width: 767px)');
    if (!mq.matches) return; // desktop: keep all default-open panels open
    ['documentation', 'faq'].forEach(function (key) {
      var panel = acc.querySelector('[data-accordion="' + key + '"]');
      if (panel) panel.removeAttribute('open');
    });
    // 'description' is intentionally left open on mobile.
  }

  function initGallery(root) {
    var track = root.querySelector('[data-bc-gallery-track]');
    var viewport = root.querySelector('[data-bc-gallery-viewport]');
    var slides = Array.from(root.querySelectorAll('[data-bc-gallery-slide]'));
    var thumbs = Array.from(root.querySelectorAll('[data-bc-thumb]'));
    if (!track || !slides.length) return;

    var current = 0;

    function goTo(idx) {
      idx = ((idx % slides.length) + slides.length) % slides.length;
      current = idx;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }

    goTo(0);

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { goTo(i); });
    });

    var prevBtn = root.querySelector('[data-bc-gallery-prev]');
    var nextBtn = root.querySelector('[data-bc-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    if (viewport) {
      var touchStartX = 0;
      viewport.addEventListener('touchstart', function (e) { touchStartX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        var delta = touchStartX - e.changedTouches[0].clientX;
        if (Math.abs(delta) > 50) goTo(delta > 0 ? current + 1 : current - 1);
      });
    }

    var galleryEl = root.querySelector('[data-bc-gallery]');
    if (galleryEl) {
      galleryEl.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  goTo(current - 1);
        if (e.key === 'ArrowRight') goTo(current + 1);
      });
    }

    root._bcGalleryGoTo = function (src) {
      var idx = thumbs.findIndex(function (t) { return t.getAttribute('data-image-src') === src; });
      if (idx >= 0) goTo(idx);
    };
  }

  function initCampaignCountdown(root) {
    root.querySelectorAll('[data-bc-campaign-end]').forEach(function (el) {
      var endIso = el.getAttribute('data-bc-campaign-end');
      if (!endIso) return;
      var endMs = new Date(endIso).getTime();
      if (isNaN(endMs)) { el.style.display = 'none'; return; }
      var now = Date.now();
      if (endMs <= now) { el.style.display = 'none'; return; }
      var daysLeft = Math.max(0, Math.ceil((endMs - now) / 86400000));
      var tpl = (window.BCStrings && window.BCStrings.campaign_days_left) || '{n} dager igjen';
      el.textContent = tpl.replace('{n}', String(daysLeft));
    });
  }

  function initWishlist(root) {
    function syncBtn(btn) {
      if (!window.BCWishlist) return;
      var on = window.BCWishlist.has(btn.getAttribute('data-id'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-wishlist-label]');
      if (label) {
        label.textContent = on ? label.getAttribute('data-label-on') : label.getAttribute('data-label-off');
      }
    }

    root.querySelectorAll('[data-wishlist="toggle"]').forEach(function (btn) {
      syncBtn(btn);

      btn.addEventListener('click', function () {
        if (!window.BCWishlist) return;
        var meta = {
          title:  btn.getAttribute('data-product-title') || '',
          url:    btn.getAttribute('data-product-url') || '',
          image:  btn.getAttribute('data-product-image') || '',
          vendor: btn.getAttribute('data-product-vendor') || ''
        };
        // Price gate (16. august 2026): B2B status is decided SERVER-SIDE in
        // Liquid and exposed as data-bc-b2b="true" on <html>
        // (layout/theme.liquid), where customer.b2b? is authoritative. Never
        // re-derive it in JS. Missing attribute = not B2B (fail closed). The
        // amount is only persisted for a B2B customer, so a saved favourite
        // cannot paint a price back into the drawer after access is gone.
        if (document.documentElement.getAttribute('data-bc-b2b') === 'true') {
          meta.price = btn.getAttribute('data-product-price') || '';
        }
        window.BCWishlist.toggle(btn.getAttribute('data-id'), meta);
      });
    });

    document.addEventListener('bc:wishlist:updated', function () {
      root.querySelectorAll('[data-wishlist="toggle"]').forEach(syncBtn);
    });
  }

  function initCompare(root) {
    root.querySelectorAll('[data-compare="toggle"]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.dispatchEvent(new CustomEvent('bc:compare:toggle', { detail: { id: btn.getAttribute('data-id') } }));
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        btn.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
